module.exports = __webpack_public_path__ + "static/media/add-branco.d671a004.svg";